import React from "react";
import { Search, Loader2 } from "lucide-react";

export default function SearchBar({ onSearch, loading, value, onChange }) {
  const submit = (e) => {
    e.preventDefault();
    if (value.trim()) onSearch(value.trim());
  };

  return (
    <form
      onSubmit={submit}
      data-testid="search-bar"
      className="bevel-in p-2 flex items-center gap-2"
      style={{ background: "linear-gradient(to bottom, #FFFDE7, #FFF59D)" }}
    >
      <div className="flex items-center gap-1 pl-1">
        <Search size={14} className="text-[#003c9e]" />
        <span className="text-[11px] font-bold text-[#003c9e]">Search:</span>
      </div>

      <input
        data-testid="search-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="e.g. Britney Spears, Linkin Park, Eiffel 65..."
        className="flex-1 bevel-in bg-white px-2 py-1.5 text-[14px] focus:outline-none focus:bg-lemon-50"
        style={{ fontFamily: '"Share Tech Mono", monospace' }}
      />

      <button
        type="submit"
        data-testid="search-submit"
        disabled={loading}
        className="bevel-btn-primary px-5 py-1.5 text-[13px] font-bold flex items-center gap-1.5 min-w-[108px] justify-center disabled:opacity-70"
      >
        {loading ? <Loader2 size={13} className="animate-spin" /> : <Search size={13} />}
        {loading ? "Searching..." : "Search!"}
      </button>

      <button
        type="button"
        data-testid="search-clear"
        onClick={() => onChange("")}
        className="bevel-btn px-3 py-1.5 text-[12.5px]"
      >
        Clear
      </button>
    </form>
  );
}
